import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
//import BaseEnv from './ConfigType/BaseEnv.js';
import Config from './ConfigType/Config.js';
import Theatre from './ConfigType/Theatre.js';
import U from './ConfigType/U.js';
import Classe from './ConfigType/Classe.js';
import Travail from './ConfigType/Travail.js';
import Ronde from './ConfigType/Ronde.js';
import Cocktail from './ConfigType/Cocktail.js';
import Vide from './ConfigType/Vide.js';
//import Lully from './ConfigType/Lully.js';
//import Foyer from './ConfigType/Foyer.js';
import ScreenGenerator from './ScreenGenerator.js';
import SimsController from './SimsMode/SimsController.js';


export default class EnvironementGenerator {
	constructor(name, scene, loadManager, camera, outlinePass, canvas, adminMode, dataLoaded) {
		this.name = name;
		this.configType;
		this.configController;
		this.scene = scene;
		this.gltfLoader = new GLTFLoader( loadManager );
		//this.roomController = new BaseEnv();
		this.camera = camera;
		this.outlinePass = outlinePass;
		this.canvas = canvas;
		this.adminMode = adminMode;
		this.dataLoaded = dataLoaded;
		this.animationActions = [];
		this.roomConfig = "";
		this.setupEnd = false;

		this.updatedScript = false;
	}

	UpdateValuesFromStart(name, scene, loadManager, camera, outlinePass, canvas, adminMode, dataLoaded) {
		this.name = name;
		this.configType;
		this.configController;
		this.scene = scene;
		this.gltfLoader = new GLTFLoader( loadManager );
		//this.roomController = new BaseEnv();
		this.camera = camera;
		this.outlinePass = outlinePass;
		this.canvas = canvas;
		this.adminMode = adminMode;
		this.dataLoaded = dataLoaded;
		this.animationActions = [];
		this.roomConfig = "";
		this.setupEnd = false;

		this.updatedScript = true;
	}

	SetAdmin(adminMode) {
		this.adminMode = adminMode;
	}

	/* 	Chargement et ajout de la pièce en 3D dans la scène
	*/
	ShowMap() {
		var mixer;
		var animationActions = [];
		let activeAction;
		this.gltfLoader.load("./models/room/" + this.name + ".glb", 
		(gltf) => {

			gltf.scene.traverse( child => {
				if ( child.isMesh ) {
					child.castShadow = true;
					child.receiveShadow = true;
				}
			});
			
			this.scene.add(gltf.scene);
			this.SetMapPart();
			

		}, undefined, function ( error ) {
			console.error( error );
		} );

	}

	/* 	Affichage uniquement des pièces/séparations choisies pour la config (que pour les Room qui sont modulables)
	*	Si le currentObject n'est pas défini ou qu'il ne correspond pas à l'objet qu'on veut afficher, on le set
	*/
	SetMapPart() {
		if(this.currentObject == undefined || this.currentObject.name != this.name) {
			this.currentObject = this.scene.getObjectByName(this.name);
		}
		this.Setup();
		switch(this.name) {
			case "Room_1_3":
				if (this.dataLoaded) {
					this.roomConfig = this.dataLoaded.d.s;
					this.configType = this.dataLoaded.c;
					this.dataToSend = this.dataLoaded.d;
					this.Show_1_3();
					this.ShowConfig(this.dataToSend);

					//this.roomController = new Room_1_3(this.scene, this.currentObject, this.dataLoaded.d.s, this.dataLoaded.c, this.dataLoaded.d);
				}
				else {
					this.roomConfig = "1";
					this.configType = "Theatre";
					this.Show_1_3();
					this.ShowConfig();
					//this.roomController = new Room_1_3(this.scene, this.currentObject, "1_2", "Theatre");
				}
				//this.SetPivot(this.roomController.SetupEnv());
				this.SetPivot();
				break;
			case "Room_4_7":
				if (this.dataLoaded) {
					this.roomConfig = this.dataLoaded.d.s;
					this.configType = this.dataLoaded.c;
					this.dataToSend = this.dataLoaded.d;
					this.Show_4_7();
					this.ShowConfig(this.dataToSend);
					
					//this.roomController = new Room_4_7(this.scene, this.currentObject, this.dataLoaded.d.s, this.dataLoaded.c, this.dataLoaded.d);
				}
				else {
					this.roomConfig = "4";
					this.configType = "Theatre";
					this.Show_4_7();
					this.ShowConfig();
					//this.roomController = new Room_4_7(this.scene, this.currentObject, "4", "Theatre");
				}
				//this.SetPivot(this.roomController.SetupEnv());
				this.SetPivot();
				break;
			case "Room_8_11":
				if (this.dataLoaded) {
					this.roomConfig = this.dataLoaded.d.s;
					this.configType = this.dataLoaded.c;
					this.dataToSend = this.dataLoaded.d;
					this.Show_8_11();
					this.ShowConfig(this.dataToSend);
					
					//this.roomController = new Room_8_11(this.scene, this.currentObject, this.dataLoaded.d.s, this.dataLoaded.c, this.dataLoaded.d);
				}
				else {
					this.roomConfig = "11";
					this.configType = "Theatre";
					this.Show_8_11();
					this.ShowConfig();
					//this.roomController = new Room_8_11(this.scene, this.currentObject, "8", "Theatre");
				}
				//this.SetPivot(this.roomController.SetupEnv());
				this.SetPivot();
				break;
			case "Lully":
				this.SetupLully();
				if (this.dataLoaded) {
					this.roomConfig = this.dataLoaded.d.s;
					this.configType = this.dataLoaded.c;
					this.dataToSend = this.dataLoaded.d;
					this.ShowConfig(this.dataToSend);

					//this.roomController = new Lully(this.scene, this.currentObject, this.dataLoaded.d.s, this.dataLoaded.c, this.dataLoaded.d);
				}
				else {
					//this.roomController = new Lully(this.scene, this.currentObject, "Lully", "Lully");
					this.roomConfig = "Lully";
					this.configType = "Theatre";
					this.ShowConfig();
				}
				//this.SetPivot(this.roomController.SetupEnv());
				this.SetPivot();
				break;
			case "Foyer":
					this.roomConfig = "Foyer";
					var obj = this.scene.children[6].children[0].children[7].children;
					this.readTextFile("./models/json/setup_foyer.json", function(text){
					    var data = JSON.parse(text);
					    this.SetupFromJSON(data);
					}.bind(this));

					if (this.dataLoaded) {
						this.roomConfig = this.dataLoaded.d.s;
						this.configType = this.dataLoaded.c;
						this.dataToSend = this.dataLoaded.d;
						this.ShowConfig(this.dataToSend);
						//this.roomController = new Lully(this.scene, this.currentObject, this.dataLoaded.d.s, this.dataLoaded.c, this.dataLoaded.d);
					}
					else {
						//this.roomController = new Lully(this.scene, this.currentObject, "Lully", "Lully");
						this.roomConfig = "Foyer";
						this.configType = "Foyer";
						this.ShowConfig();
					}
/*
					for (var i = 0; i < obj.length; i++) {
						if (obj[i].name.includes("Pot")) {
							console.log("{\"name\":\"Pot\", \"position\":" + JSON.stringify(obj[i].position) + ",\"rotation\":" + JSON.stringify(obj[i].rotation) + "}")
						}

						if (obj[i].name.includes("Coin_Gueridon")) {
							for (var j = 0; j < obj[i].children.length; j++) {
								if (obj[i].children[j].name.includes("SM_FauteuilGrandGris_Coussin")) {
									console.log("{\"name\":\"Fauteuil_Grand_Gris\", \"position\":" + JSON.stringify(obj[i].children[j].position) + ",\"rotation\":" + JSON.stringify(obj[i].children[j].rotation) + "}")
								}
							}
						}
					}*/
				break;
		}

		this.setupEnd = true;
	}

	readTextFile(file, callback) {
	    var rawFile = new XMLHttpRequest();
	    rawFile.overrideMimeType("application/json");
	    rawFile.open("GET", file, true);
	    rawFile.onreadystatechange = function() {
	        if (rawFile.readyState === 4 && rawFile.status == "200") {
	            callback(rawFile.responseText);
	        }
	    }
	    rawFile.send(null);
	}

	SetupFromJSON(data) {
		var newPos;
		var simsData = {canMove: true, visible: true, added: false, id: 0, moved: false, basePos:{x: 0, y: 0, z: 0}, rotated: false, baseRot:{x: 0, y: 0, z: 0}};
		for (var i = 0; i < data.objectToAdd.length; i++){
			newPos = {posX:data.objectToAdd[i].position.x, posY:data.objectToAdd[i].position.y, posZ:data.objectToAdd[i].position.z,
						rotX:data.objectToAdd[i].rotation.x, rotY:data.objectToAdd[i].rotation.y, rotZ:data.objectToAdd[i].rotation.z};
			simsData.id = data.objectToAdd[i].id;
			if (data.objectToAdd.length - 1 == i && this.configController.simsDataFunction) {
				var functionToSend = function(e){
					this.configController.simsDataFunction();
				}.bind(this);
				newPos.functionToAdd = functionToSend;
			}
			this.simsController.objectGenerator.AddElement("bibliotheque/" + data.objectToAdd[i].name, this.whereToAddObjects, newPos, undefined, structuredClone(simsData));
		}
	}

	Setup() {
		this.mapPart = [];
		this.mapSeparation = [];
		this.plafondObject = this.currentObject.getObjectByName("Plafond_" + this.name.replace("Room_",""));
		this.groundObject = this.currentObject.getObjectByName("Ground_" + this.name.replace("Room_",""));


		this.plafondObject.castShadow = false;
		this.plafondObject.visible = false;

		var child = this.currentObject.children;

		for (let i = 0; i < child.length; i++) {
			if (child[i].name.includes("Room")) {
				this.mapPart.push(child[i]);
			}
			else if (child[i].name.includes("Separation")) {
				this.mapSeparation.push(child[i]);
			}
		}

		if (!this.whereToAddObjects) {
			this.whereToAddObjects = new THREE.Object3D();
			this.whereToAddObjects.name = "WhereToAddObjects";
			this.currentObject.add(this.whereToAddObjects);
		}
		
		this.simsController = new SimsController(this.camera, this.whereToAddObjects, this.outlinePass, this.canvas);
	}

	SetupLully() {
		this.tribune = this.currentObject.getObjectByName("Tribune");
		this.isAnimate = false;
		this.functionToPlayAfterAnim;

		this.isTribuneOpen = {
			tribune: 1,
			marche: 1,
			etage: 1,
			siege: 1,
			marcheMin: 0,
			marcheMax: 0.5,
			etageMin: 0,
			etageMax: 1,
			siegeMin: 0,
			siegeMax: (Math.PI/18)*8
		};
	}

	Show_1_3() {
		switch(this.roomConfig) {
			case "1": 
				this.ShowRoom(["Room_1"]);
				this.ShowGround();

				this.ShowSeparation(["Separation_1"]);
				break;
			case "2": 
				this.ShowRoom(["Room_2"]);
				this.ShowGround();

				this.ShowSeparation(["Separation_1", "Separation_2"]);
				break;
			case "3": 
				this.ShowRoom(["Room_3"]);
				this.ShowGround();

				this.ShowSeparation(["Separation_2"]);
				break;
			case "1_2": 
				this.ShowRoom(["Room_1", "Room_1_2"]);
				this.ShowGround();

				this.ShowSeparation(["Separation_2"]);
				break;
			case "2_3": 
				this.ShowRoom(["Room_2_3", "Room_3"]);
				this.ShowGround();

				this.ShowSeparation(["Separation_1"]);
				break;
			case "1_2_3": 
				this.ShowRoom(["Room_1", "Room_1_2_3", "Room_3"]);
				this.ShowGround();

				this.ShowSeparation([]);
				break;
		}
	}

	Show_4_7() {
		switch(this.roomConfig) {
			case "4": 
				this.ShowRoom(["Room_4"]);
				this.ShowGround();

				this.ShowSeparation(["Separation_4"]);
				break;
			case "5": 
				this.ShowRoom(["Room_4", "Room_5"]);
				this.ShowGround();

				this.ShowSeparation(["Separation_5"]);
				break;
			case "6": 
				this.ShowRoom(["Room_4", "Room_5", "Room_6"]);
				this.ShowGround();

				this.ShowSeparation(["Separation_6"]);
				break;
			case "7": 
				this.ShowRoom(["Room_4", "Room_5", "Room_6", "Room_7"]);
				this.ShowGround();

				this.ShowSeparation(["Separation_7"]);
				break;
		}
	}

	Show_8_11() {
		switch(this.roomConfig) {
			case "8": 
				this.ShowRoom(["Room_8", "Room_9", "Room_10", "Room_11"]);
				this.ShowGround();

				this.ShowSeparation(["Separation_8"]);
				break;
			case "9": 
				this.ShowRoom(["Room_9", "Room_10", "Room_11"]);
				this.ShowGround();

				this.ShowSeparation(["Separation_9"]);
				break;
			case "10": 
				this.ShowRoom(["Room_10", "Room_11"]);
				this.ShowGround();

				this.ShowSeparation(["Separation_10"]);
				break;
			case "11": 
				this.ShowRoom(["Room_11"]);
				this.ShowGround();

				this.ShowSeparation(["Separation_11"]);
				break;
		}
	}

	ShowRoom(roomList) {
		for (let i = 0; i < this.mapPart.length; i++) {
			this.mapPart[i].visible = false;
			for(let n = 0; n < roomList.length; n++) {
				if (this.mapPart[i].name == roomList[n]) {
					this.mapPart[i].visible = true;
				}
			}
		}
	}

	ShowGround() {
		for (var i = 0; i < this.groundObject.children.length; i++) {
			if (this.groundObject.children[i].name == ("Ground_" + this.roomConfig)) {
				this.groundObject.children[i].visible = true;
			}
			else {
				this.groundObject.children[i].visible = false;
			}
		}
	}

	ShowSeparation(sepList) {
		for (let i = 0; i < this.mapSeparation.length; i++) {
			this.mapSeparation[i].visible = false;
			for(let n = 0; n < sepList.length; n++) {
				if (this.mapSeparation[i].name == sepList[n]) {
					this.mapSeparation[i].visible = true;
				}
			}
		}
	}

	/*	Déplace les pièces pour que le point de pivot de la scène soit au centre
	*/
	SetPivot() {
		var currentRoom;
		if (this.roomConfig == "Lully") {
			currentRoom = this.currentObject.getObjectByName(this.roomConfig);
		}
		else {
			currentRoom = this.currentObject.getObjectByName("Room_" + this.roomConfig);
		}
		this.currentObject.position.set(currentRoom.position.x * -1, currentRoom.position.y * -1, currentRoom.position.z * -1);
	}

	ShowConfig(data) {
		switch(this.configType) {
			case "Theatre":
				if (!(this.configController instanceof Theatre)) {
					this.configController = new Theatre(this.currentObject, this.name.replace('Room_', ''), this.roomConfig, this.whereToAddObjects, data);
				}
				else {
					if (this.updatedScript) {
						this.configController = new Theatre(this.currentObject, this.name.replace('Room_', ''), this.roomConfig, this.whereToAddObjects, data);
					}
					else {
						this.configController.ChangeRoomConfig(this.name.replace('Room_', ''), this.roomConfig);
					}
				}
				break;
			case "U":
				if (!(this.configController instanceof U)) {
					this.configController = new U(this.currentObject, this.name.replace('Room_', ''), this.roomConfig, this.whereToAddObjects, data);
				}
				else {
					this.configController.ChangeRoomConfig(this.name.replace('Room_', ''), this.roomConfig);
				}
				break;
			case "Classe":
				if (!(this.configController instanceof Classe)) {
					this.configController = new Classe(this.currentObject, this.name.replace('Room_', ''), this.roomConfig, this.whereToAddObjects, data);
				}
				else {
					this.configController.ChangeRoomConfig(this.name.replace('Room_', ''), this.roomConfig);
				}
				break;
			case "Travail":
				if (!(this.configController instanceof Travail)) {
					this.configController = new Travail(this.currentObject, this.name.replace('Room_', ''), this.roomConfig, this.whereToAddObjects, data);
				}
				else {
					this.configController.ChangeRoomConfig(this.name.replace('Room_', ''), this.roomConfig);
				}
				break;
			case "Ronde":
				if (!(this.configController instanceof Ronde)) {
					this.configController = new Ronde(this.currentObject, this.name.replace('Room_', ''), this.roomConfig, this.whereToAddObjects, false, data);
				}
				else {
					this.configController.ChangeRoomConfig(this.name.replace('Room_', ''), this.roomConfig, false);
				}
				break;
			case "Cocktail":
				if (!(this.configController instanceof Cocktail)) {
					this.configController = new Cocktail(this.currentObject, this.name.replace('Room_', ''), this.roomConfig, this.whereToAddObjects, false, data);
				}
				else {
					this.configController.ChangeRoomConfig(this.name.replace('Room_', ''), this.roomConfig, false);
				}
				break;
			case "Diner":
				if (!(this.configController instanceof Ronde)) {
					this.configController = new Ronde(this.currentObject, this.name.replace('Room_', ''), this.roomConfig, this.whereToAddObjects, true, data);
				}
				else {
					this.configController.ChangeRoomConfig(this.name.replace('Room_', ''), this.roomConfig, true);
				}
				break;
			case "Danse":
				if (!(this.configController instanceof Cocktail)) {
					this.configController = new Cocktail(this.currentObject, this.name.replace('Room_', ''), this.roomConfig, this.whereToAddObjects, true, data);
				}
				else {
					this.configController.ChangeRoomConfig(this.name.replace('Room_', ''), this.roomConfig, true);
				}
				break;
			case "Vide":
				if (!(this.configController instanceof Vide)) {
					this.configController = new Vide(this.currentObject, this.name.replace('Room_', ''), this.roomConfig, this.whereToAddObjects, data);
				}
				else {
					this.configController.ChangeRoomConfig(this.name.replace('Room_', ''), this.roomConfig);
				}
				break;
		}

		if (this.name == "Foyer") {
			this.configController = new Config(this.currentObject, this.currentObject, this.roomConfig, this.whereToAddObjects, data);
		}
		else if (this.name == "Lully") {
			if (this.configType == "Theatre") {
				if (!this.isTribuneOpen.tribune) {
					this.functionToPlayAfterAnim = function(e){
						this.configController.ShowLully();
					}.bind(this);
				}
				else {
					this.configController.ShowLully();
				}
			}
			else {
				if (this.isTribuneOpen.tribune) {
					this.functionToPlayAfterAnim = function(e){
						this.configController.Show();
					}.bind(this);
				}
				else {
					this.configController.Show();
				}
			}
		}
		else {
			this.configController.Show();
		}

		if (data) {
			this.configController.SetSimsDataFunction(function() {
				this.simsController.SetSimsData(data.sm);
			}.bind(this));
		}
	}

	GetConfigData() {
		return this.configController.GetData();
	}


	ChangeRoom(newRoomValue) {
		this.roomConfig = newRoomValue;
		this.UpdateCamPos();

		switch(this.name) {
			case "Room_1_3":
				this.Show_1_3();
				break;
			case "Room_4_7":
				this.Show_4_7();
				break;
			case "Room_8_11":
				this.Show_8_11();
				break;
			case "Lully":
				break;
			case "Foyer":
				break;
		}
		this.SetPivot();
	}


/*
	ResetBaseConfig(){
		if (this.configController) {
			this.configController.ResetBaseConfig();
		}
	}*/

	/*	Change le type de configuration de la pièce
	*/
	ChangeConfigType(type) {
		var isSameType = type == this.configType;
		this.configType = type;

		if (this.configController && !this.updatedScript) {
			if (!isSameType) {
				this.configController.DropAllObjectAdded();
			}
			if (this.dataLoaded) {
				this.SetMapPart();
			}
			else {
				this.ShowConfig();
			}
		}
		else {
			this.ShowMap();
		}
		//this.roomController.ChangeConfigType(type);
	}


	ChangeConfigValue(value) {
		this.configController.Modify(value);
	}


	PlayAnimation(dt, todo) {
		this.isTribuneOpen.tribune = !todo;

		if (todo) {
			this.isAnimate = true;
			return this.OpenTribune((dt) * -1);
		}
		else {
			this.isAnimate = true;
			return this.CloseTribune(dt);
		}
	}

	OpenTribune(move) {
		var currentValue;
		if (this.isTribuneOpen.etage != 1) {
			currentValue = this.BrowseStages(this.tribune.children[0], move, "Etage");
			this.isTribuneOpen.etage = 2;

			if (currentValue < this.isTribuneOpen.etageMin) {
				this.isTribuneOpen.etage = 1;
			}
		}
		else if (this.isTribuneOpen.siege != 1) {
			currentValue = this.BrowseStages(this.tribune.children[0], move, "Siege");
			this.isTribuneOpen.siege = 2;

			if (currentValue < this.isTribuneOpen.siegeMin) {
				this.isTribuneOpen.siege = 1;
			}
		}
		else if (this.isTribuneOpen.marche != 1) {
			currentValue = this.BrowseStages(this.tribune.children[0], move, "Marche");
			this.isTribuneOpen.marche = 2;

			if (currentValue < this.isTribuneOpen.marcheMin) {
				this.isTribuneOpen.marche = 1;
				this.isTribuneOpen.tribune = true;
				this.isAnimate = false;
				if (this.functionToPlayAfterAnim) {
					this.functionToPlayAfterAnim();
				}
			}
		}
		return !this.isTribuneOpen.tribune;
	}

	CloseTribune(move) {
		var currentValue;
		if (this.isTribuneOpen.marche != 3) {
			currentValue = this.BrowseStages(this.tribune.children[0], move, "Marche");
			this.isTribuneOpen.marche = 2;

			if (currentValue > this.isTribuneOpen.marcheMax) {
				this.isTribuneOpen.marche = 3;
			}
		}
		else if (this.isTribuneOpen.siege != 3) {
			currentValue = this.BrowseStages(this.tribune.children[0], move, "Siege");
			this.isTribuneOpen.siege = 2;

			if (currentValue > this.isTribuneOpen.siegeMax) {
				this.isTribuneOpen.siege = 3;
			}
		}
		else if (this.isTribuneOpen.etage != 3) {
			currentValue = this.BrowseStages(this.tribune.children[0], move, "Etage");
			this.isTribuneOpen.etage = 2;

			if (currentValue > this.isTribuneOpen.etageMax) {
				this.isTribuneOpen.etage = 3;
				this.isTribuneOpen.tribune = false;
				this.isAnimate = false;
				if (this.functionToPlayAfterAnim) {
					this.functionToPlayAfterAnim();
				}
			}
		}

		return this.isTribuneOpen.tribune;
	}

	BrowseStages(object, move, name) {
		var nextStage = null;
		var currentValue = 0;
		var speedTranslate = 0.3;
		var speedRotation = 0.5;

		for (var i = 0; i < object.children.length; i++) {
			if (object.children[i].name.includes("Etage")) {
				nextStage = object.children[i];
			}
			if (object.children[i].name.includes(name)) {
				if (name != "Siege") {
					object.children[i].translateX(move * speedTranslate);
					currentValue = object.children[i].position.x;
				}
				else if (!object.children[i].name.includes("Base")){
					/*var axesHelper = new THREE.AxesHelper( 5 );
					object.children[i].add(axesHelper);*/
					object.children[i].rotation.z += (move * speedRotation);
					currentValue = object.children[i].rotation.z;
				}
			}
		}

		if (nextStage != null) {
			this.BrowseStages(nextStage, move, name);
		}

		return currentValue;
	}


	GenerateLink() {
		var link = window.location.href.split('?')[0];
		link += "?r=" + this.name;
		link += "&c=" + this.configType;
		link += "&d=" + this.GetLinkData();

		return link;
	}

	GetLinkData() {
		var data = "{";
		var configData = this.configController.GetData();
		data += "\"s\":\"" + this.roomConfig + "\"";
		switch(this.configType) {
			case "Theatre":
				data += ",\"er\":\"" + configData.entreRange + "\"";
				data += ",\"ro\":\"" + configData.rangeOffset + "\"";
				data += ",\"nbc\":\"" + configData.chaiseCount + "\"";
				data += ",\"p\":\"" + configData.praticable + "\"";
				data += ",\"so\":\"" + configData.switchOrientation + "\"";
				data += ",\"em\":\"" + configData.isEcranMural + "\"";
				break;
			case "U":
				data += ",\"nb\":\"" + configData.nbTableBaseU + "\"";
				data += ",\"n\":\"" + configData.nbTableU + "\"";
				data += ",\"nbt\":\"" + configData.currentNbTable + "\"";
				data += ",\"em\":\"" + configData.isEcranMural + "\"";
				break;
			case "Classe":
				data += ",\"et\":\"" + configData.entreTable + "\"";
				data += ",\"er\":\"" + configData.entreRange + "\"";
				data += ",\"nbt\":\"" + configData.tableCount + "\"";
				data += ",\"p\":\"" + configData.praticable + "\"";
				data += ",\"em\":\"" + configData.isEcranMural + "\"";
				break;
			case "Travail":
				data += ",\"ep\":\"" + configData.entrePole + "\"";
				data += ",\"nbt\":\"" + configData.poleCount + "\"";
				data += ",\"p\":\"" + configData.praticable + "\"";
				data += ",\"em\":\"" + configData.isEcranMural + "\"";
				break;
			case "Diner":
			case "Ronde":
				data += ",\"et\":\"" + configData.entreTable + "\"";
				data += ",\"nbt\":\"" + configData.tableCount + "\"";
				data += ",\"ppt\":\"" + configData.personneParTable + "\"";
				data += ",\"em\":\"" + configData.isEcranMural + "\"";
				break;
			case "Cocktail":
				data += ",\"et\":\"" + configData.entreTable + "\"";
				data += ",\"nbt\":\"" + configData.cocktailCount + "\"";
				data += ",\"em\":\"" + configData.isEcranMural + "\"";
				break;
			case "Vide":
				data += ",\"em\":\"" + configData.isEcranMural + "\"";
				break;
		}
		data += ",\"sm\":[" + this.simsController.GetSimsData() + "]";

		data += "}";
		return data;
	}


	SwitchView(value, camera) {
		this.viewCamera = camera;
		this.fpsView = value;

		if (value) {
			this.plafondObject.visible = true;
			this.UpdateCamPos();
	        
			for (var i = 0; i < this.whereToAddObjects.children.length; i++) {
				if (this.whereToAddObjects.children[i].name == "Text") {
					if (this.whereToAddObjects.children[i].rotation.z != 0) {
						this.whereToAddObjects.children[i].rotation.x = 0;
						if (this.currentRoom == "1" || this.currentRoom == "3") {
							this.whereToAddObjects.children[i].rotation.y = Math.PI/2;
						}
						else {
							this.whereToAddObjects.children[i].rotation.y = -Math.PI/2;
						}
						this.whereToAddObjects.children[i].rotation.z = 0;
					}
					else {
						this.whereToAddObjects.children[i].rotation.x = 0;
					}

					this.whereToAddObjects.children[i].translateY(-0.5);
				}
			}
		}
		else if (this.plafondObject) {
			this.plafondObject.visible = false;
			for (var i = 0; i < this.whereToAddObjects.children.length; i++) {
				if (this.whereToAddObjects.children[i].name == "Text") {
					this.whereToAddObjects.children[i].translateY(0.5);

					if (this.whereToAddObjects.children[i].rotation.y != 0) {
						this.whereToAddObjects.children[i].rotation.x = -Math.PI/2;
						this.whereToAddObjects.children[i].rotation.y = 0;
						if (this.currentRoom == "1" || this.currentRoom == "3") {
							this.whereToAddObjects.children[i].rotation.z = Math.PI/2;
						}
						else {
							this.whereToAddObjects.children[i].rotation.z = -Math.PI/2;
						}
					}
					else {
						this.whereToAddObjects.children[i].rotation.x = -Math.PI/2;
					}

				}
			}
		}
	}

	UpdateCamPos() {
		if (this.fpsView) {
			//var basePos = this.firstPersonViewObject.getObjectByName("FPS_" + this.currentRoom);
			var initialPosition = new THREE.Vector3();

			/*if (basePos) {
				basePos.getWorldPosition(initialPosition);
				initialPosition.y = 1.7;
			}
			else {*/
				initialPosition = new THREE.Vector3(0, 1.7, 0);
			//}

			var initialRotation = new THREE.Euler(0, 0, 0, 'YXZ');
	        this.viewCamera.position.copy(initialPosition);
	        this.viewCamera.rotation.copy(initialRotation);
	    }
	}

	Clicked(mousepPos) {
		this.MoveCam(mousepPos);
		if (this.adminMode) {
			this.simsController.CheckRaycast(mousepPos);
		}
	}

	MoveCam(mousepPos) {
		if (this.fpsView) {
			const raycaster = new THREE.Raycaster();
			raycaster.setFromCamera(mousepPos, this.viewCamera);

			const intersects = raycaster.intersectObjects(this.currentObject.children, true);
			if (intersects.length > 0) {
				for (var i = 0; i < intersects.length; i++) {
					if (intersects[i].object.visible) {
						if (intersects[i].object.name.includes("Ground")) {
							var newPos = intersects[i].point;
							newPos.y += 1.7;
							this.viewCamera.position.copy(newPos);
							break;
						}
						else if (intersects[i].object.name.includes("Bord") || intersects[i].object.parent.name.includes("Bord") 
							|| intersects[i].object.name.includes("Room_") || intersects[i].object.name.includes("Separation_")) {
							break;
						}
					}
				}
			}
		}
	}

	AddMeasureForScreen() {
		this.ScreenGenerator = new ScreenGenerator(this.roomConfig, this.scene, this.whereToAddObjects, this.configType, this.configController);
		this.ScreenGenerator.AddMeasure();
	}

	ClearMeasureForScreen() {
		this.ScreenGenerator.ClearTempLines();
	}

	allMeasureDone() {
		return this.ScreenGenerator.isAllMeasureDone;
	}
}